<template>
	<div>
		<div class="head">
			<img src="@/assets/headImg/headimg.jpg" style="width: 100%; 
		vertical-align:top;" class="lunbo1" />
			<img src="../../assets/lunbo.jpg" style="width: 100%;" class="lunbo2">
		</div>
		<div class="success_box">
			<div>
				<pcBack></pcBack>
			</div>
			<div class="qf_box">
				<div v-if="status == 1">
					<div class="text">
						<p>({{name}})线上缴费：未成功</p>
						<span>诚挚欢迎您参与中华医学会第一次全国细菌真菌感染学术会议，您已完成线下参会报名，
							为了不影响您后续的参会流程，请您通过下方线下参会支付按钮完成缴费。
							如您对参会注册有任何疑问，请通过联系我们模块进行详细咨询，感谢您的支持！</span>
						<span style="display: none;">线上缴费通道已关闭，如您已报名线下参会，请于4月8日前往上海跨国采购会展中心现场签到并缴费。
							如您对参会注册有任何疑问，请通过联系我们模块进行详细咨询，感谢您的支持！</span>
					</div>
					<div class="flex" style="width: 90%;margin: 0 auto;">
						<div class="btn" type="submit" @click="signOut">退出登录</div>
						<div class="btn" @click="toPayUrl">线上缴费(200元)</div>
					</div>
				</div>
				<div v-if="status == 2">
					<div class="text">
						<p>({{name}})线上缴费：已成功</p>
						<span>诚挚欢迎您参与中华医学会第一次全国细菌真菌感染学术会议，您已通过线上缴费方式完成参会注册，
							请您于4月8日当天前往上海跨国采购会展中心进行会议报到。
							如您对参会注册有任何疑问，请通过联系我们模块进行详细咨询，感谢您的支持！</span>

					</div>
					<div class="flex" style="width: 90%;margin: 0 auto;">
						<div class="btn" type="submit" @click="signOut">退出登录</div>
						<!-- <div class="btn_not">线上缴费（200元）</div> -->
					</div>
				</div>
				<div v-if="status == 3">
					<div class="text">
						<p>({{name}})线上参会：</p>
						<span>诚挚欢迎您参与中华医学会第一次全国细菌真菌感染学术会议，您已完成线上参会报名，感谢您对本次会议的关注！</span>
					</div>
					<div class="flex" style="width: 90%;margin: 0 auto;">
						<div class="btn" type="submit" @click="signOut">退出登录</div>
						<!-- <div class="btn_not">线上缴费(200元)</div> -->
					</div>
				</div>
				<div v-if="status == 4">
					<div class="text">
						<p>({{teamName}}&nbsp;,&nbsp;{{name}})团队参会：</p>
						<span>诚挚欢迎您参与中华医学会第一次全国细菌真菌感染学术会议，您已通过团队注册完成线下会议注册，
							请您于4月8日当天前往上海跨国采购会展中心进行会议报到。
							如您对参会注册有任何疑问，请通过联系我们模块进行详细咨询，感谢您的支持！</span>
					</div>
					<div class="flex" style="width: 90%;margin: 0 auto;">
						<div class="btn" type="submit" @click="signOut">退出登录</div>
						<div class="btn" @click="dialogVisible = true">修改信息</div>
						<!-- <div class="btn_not">线上缴费(200元)</div> -->
					</div>
				</div>
			</div>
		</div>
		
		<el-dialog title="提示" :visible.sync="dialogVisible" width="80%" :before-close="()=>{dialogVisible=false}"
		 :close-on-click-modal=false>
		
			<div>
				<el-form :model="reForm" status-icon :rules="rules" ref="reForm" class="demo-ruleForm">
					<el-form-item label="真实姓名" prop="name">
						<el-input v-model="reForm.name" placeholder="请输入姓名"></el-input>
					</el-form-item>

					<el-form-item label="身份证号" prop="IdCard">
						
						<el-input v-model="reForm.IdCard" placeholder="请输入身份证号"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="submitUpdate(reForm)" style="width: 100%;margin-top: 1.25rem;">提交</el-button>
					</el-form-item>
				</el-form>
			</div>

		</el-dialog>
		<div>
			<logocom></logocom>
		</div>
	</div>
</template>

<script>
	import pcBack from '../../components/back/back.vue';
	import logocom from '../../components/logo/logo.vue'
	export default {
		data() {
			// 身份证验证
			var yzID = (rule, value, callback) => {
				var reg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
				console.log(value, '999');
				setTimeout(() => {
					if (!(reg.test(value))) {
						callback(new Error('请输入有效的身份证号'));
					} else {
						return callback();
					}
			
				}, 500);
			};
			return {
				dialogVisible:false,
				orderAmount: '200',
				status: '',
				name: '',
				teamName: '',
				reForm: {
					name: '',
					IdCard: '',
					userId:'',
				},
				rules: {
					IdCard: {
						validator: yzID,
						trigger: 'blur',
						required: true
					}
				},
			}
		},
		components: {
			pcBack,
			logocom
		},
		methods: {
			submitUpdate() {
				let cnt = {
					IdCard: this.reForm.IdCard,
					userId: this.reForm.userId,
					name: this.reForm.name,
				}
				this.$api.updateUser(cnt, res => {
					if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
						this.$message({
							message: '修改成功',
							type: 'success',
						})
						this.dialogVisible = false;
					}
				})
			},
			signOut() {
				var r = confirm("是否确认退出");
				if (r == true) {
					this.$api.exit({
						userId: JSON.parse(localStorage.getItem("user")).user.userId
					}, res => {
						localStorage.removeItem('user');
						sessionStorage.removeItem('openId')
						sessionStorage.removeItem('unionId')
						sessionStorage.removeItem('nickName')
						sessionStorage.removeItem('headImg')
						this.$router.push({
							path: '/signIn'
						})
					})
				}
			},
			information() {
				if (!localStorage.getItem('user')) {
					this.$router.push({
						path: '/phone'
					})

				}
			},
			retrun_home: function() {
				this.$router.push({
					path: '/phone'
				})
			},
			retrun_pc: function() {
				this.$router.push({
					path: '/'
				})
			},
			toPayUrl() {
				// console.log("user", JSON.parse(localStorage.getItem('user')));
				var user = JSON.parse(localStorage.getItem('user'));
				this.userId = user.user.userId;
				let cnt = {
					orderAmount: this.orderAmount, // String 金額
					userId: this.userId, // Long 用户编号
				};
				this.$api.pay(cnt, res => {
					if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
						window.location = res.data.c
					}
				})
			},
		},
		created() {
			this.information();
			let userForm = JSON.parse(localStorage.getItem('user'));
			this.name = userForm.user.name
			this.reForm.IdCard = userForm.user.idCard
			this.reForm.name = userForm.user.name
			this.reForm.userId = userForm.user.userId
			let cnt = {
				userId: userForm.user.userId,
				count: 100,
				offset: 0
			}
			this.$api.getPayOrderInfectList(cnt, res => {
				if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
					let orderForm = JSON.parse(res.data.c)
					if (userForm.user.isonline == "是") {
						this.status = 3;
						
					} else if (userForm.user.isTeam == 1) {
						// userForm.user.exceltab != undefined || userForm.user.exceltab != "" || userForm.user.exceltab != null
						this.status = 4;
						this.teamName = userForm.user.teamName
					} else {
						if (orderForm.list.length > 0) {
							for (var i = 0; i < orderForm.list.length; i++) {
								if (orderForm.list[i].status == 2) {
									this.status = 2;
								}
							}
							if (this.status != 2) {
								this.status = 1;
							}
						} else {
							this.status = 1;
						}
					}
				}
			})
		}
	}
</script>

<style scoped>
	.signOut {
		margin-left: 50%;
		transform: translateX(-50%);
		font-size: 16px;
		color: #545454;
		cursor: pointer;
		margin-top: 10px;
		border: none;
		background-image: linear-gradient(to right, #5173ff, #3dbbff);
		color: #fff;
		border-radius: 3px;
		width: 120px;
		height: 35px;
	}

	.success_box {
		width: 980px;
		margin: 1.25rem auto;
	}

	.box {
		margin: 0 auto;
	}

	.retrun_pc {
		margin: 20px 0;
		cursor: pointer;
		color: #4fb3ff;
	}

	.qf_box {
		width: 430px;
		margin: 0 auto;
	}

	.retrun_pc:hover {
		color: #49a8eb;
	}

	.text {
		margin-top: 50px;
		color: #666;
		padding-bottom: 1.25rem;
		width: 90%;
		margin: 0 auto;
	}

	.text p {
		margin: 0rem;
		font-size: 1.125rem;
		font-weight: bold;
		text-align: center;
		padding-bottom: 1.25rem;
	}

	.text span {
		display: inline-block;
		line-height: 1.5625rem;
		text-align: left;
		font-size: 1rem;
		text-indent: 2rem;
	}

	.head {
		width: 980px;
		margin: 0 auto;
		padding-right: 16px;
	}

	.lunbo2 {
		display: none;
	}

	.isshow {
		visibility: hidden;
	}

	@media (max-width:500px) {
		.lunbo1 {
			display: none;
		}

		.lunbo2 {
			display: block;
		}

		.isshow {
			visibility: visible;
		}

		.head {
			width: 100%;
		}

		.qf_box {
			width: 100%;
		}

		.text {
			margin-top: 50px;
			margin: 0 auto;
		}

		.text p {
			margin-top: 3.125rem;
		}

		.success_box {
			margin-top: 100px;
			width: 90%;
			margin: 0 auto;
		}

		.retrun {
			/* 	font-size: 20px;
			font-weight: bold;
			color: #1e65ff;
			text-align: center;
			margin-bottom: 30px;
			background-color: #eeeeee; */
			margin: 0 auto;
			line-height: 40px;
			text-align: center;
			background-color: #5e89ff;
			color: #fff;
			border-radius: 5px;
			width: 80%;
			/* margin-bottom: 20px; */
			position: fixed;
			bottom: 10px;
			margin-left: 50%;
			transform: translateX(-50%);

		}

		.btn-box {
			position: fixed;
			margin-left: 50%;
			transform: translateX(-50%);
			width: 100%;
			background-color: #fff;
			bottom: 0;
			height: 50px;
		}
	}

	@media (max-width:500px) {
		.phone_return {
			display: none;
		}
	}

	.btn {
		background-image: linear-gradient(to right, #5173ff, #3dbbff);
		width: 40%;
		height: 35px;
		line-height: 35px;
		border-radius: 5px;
		color: #fff;
		text-align: center;
		font-size: 15px;
		cursor: pointer;
		margin: 0 auto;
	}

	.btn_not {
		background-image: linear-gradient(to right, #636363, #7f7f7f);
		width: 150px;
		height: 35px;
		line-height: 35px;
		border-radius: 5px;
		color: #fff;
		text-align: center;
		font-size: 15px;
		cursor: pointer;
	}

	.flex {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
</style>
